import { Component,OnInit} from '@angular/core';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmationService, Message } from 'primeng/api';

@Component({
  selector: 'app-part-drawing',
  templateUrl: './part-drawing.component.html',
  styleUrls: ['./part-drawing.component.scss']
})
export class PartDrawingComponent {
  partDrawingdata: any;
  submitButton: string = 'Submit'
  editItemId: any;
  msgs: Message[] = [];
  ngOnInit(){
    this.getPartDrawingData();
  }
  constructor(private _utility: AppUtility, private _apiService : ApiServiceService,private confirmService : ConfirmationService){

  }
  breadcrumb = [
    {
      title: 'Part Drawing',
      subTitle: 'Part Drawing'
    }
  ];

  getPartDrawingData() {
    this._utility.loader(true);
    this._apiService.getPartDrawing()
      .then((res: any) => {
        this._utility.loader(false);
        if (res.success == true) {
          console.log(res);
          this.partDrawingdata = res.returnValue;
        }
        else {
          console.log("getPartDrawing got an error");
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        console.log(error);
      })
  }

  partDrawingForm = new FormGroup({
    partDrawingName: new FormControl('', [Validators.required]),
    PartDrawingDescription: new FormControl('', [Validators.required])
  });

  partDrawingFormSubmit(partDrawing: FormGroupDirective) {
    console.log(this.partDrawingForm.value);
    if (this.partDrawingForm.valid) {
      this._utility.loader(true);
      let object = this.partDrawingForm.value;
      if (this.submitButton == 'Submit') {
        this._apiService.addPartDrawingName(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success')
            window.scroll(0, 0)
            this.partDrawingForm.reset();
            Object.keys(this.partDrawingForm.controls).forEach(key => {
              this.partDrawingForm.controls[key].setErrors(null)
            });
            partDrawing.resetForm();
            this.getPartDrawingData();
          }
          else {
            this._apiService.showMessage(res.message, 'success');
          }

        })
      }
      else {
        object['partId'] = this.editItemId;
        console.log(object);
        this._apiService.editPartDrawingName(object).then((res: any) => {
          this._utility.loader(false);
          if (res.success == true) {
            this._apiService.showMessage(res.message, 'success');
            this.partDrawingForm.reset();
            Object.keys(this.partDrawingForm.controls).forEach(key => {
              this.partDrawingForm.controls[key].setErrors(null)
            });
            partDrawing.resetForm();
            this.submitButton = 'Submit'
            this.getPartDrawingData();
          }

          else {
            this._apiService.showMessage(res.message, 'error');
          }
        })
      }
    }
  }
  EditItem(data: any) {
    if (data.partId) {
      Object.keys(this.partDrawingForm.controls).forEach(key => {
        this.partDrawingForm.controls[key].setValue(data[key]);
      });
      this.submitButton = 'Update'
      this.editItemId = data.partId;
    }
  }
  confirm1(partId: any) {
    this.confirmService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Delete Part Drawing Record',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(partId);
        this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
      },
      reject: () => {
        this.msgs = [{ severity: 'info', summary: 'Rejected', detail: 'You have rejected' }];
      }
    });
  }

  deleteItem(itemId: any) {
    this._utility.loader(true);
    this._apiService.deletePartDrwaingRecord(itemId)
    .then((res: any) => {
      this._utility.loader(false);
      console.log(res);      
      if (res.success == true) {
        this._apiService.showMessage(res.message, 'success');
        this.getPartDrawingData();
      }

      else {
        window.scroll(0, 0);
        this._apiService.showMessage(res.message, 'error');
        this.getPartDrawingData();
      }

    })
  }


}
